module.exports = __webpack_public_path__ + "static/media/materialAwesome.e76c6f47.woff";